module.exports = __webpack_public_path__ + "static/media/standing-arm-circles.90bb7673.png";